import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

/**
 * Single taxonomy slug write entry (create | setSlug | deleteSubtree).
 * @param {object} payload
 */
const writeCatalogTaxonomySlug = async (payload = {}) => {
  try {
    const callable = functions.httpsCallable('writeCatalogTaxonomySlug')
    const result = await callable(payload)
    return {
      ok: true,
      data: result.data,
    }
  } catch (error) {
    console.error('[writeCatalogTaxonomySlug] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default writeCatalogTaxonomySlug
